var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingZones.dialog.province"),
                prop: "provinceId",
              },
            },
            [
              _c("BjSelectChinaArea", {
                staticClass: "full-width",
                attrs: { all: "" },
                on: { change: _vm.changeProvince },
                model: {
                  value: _vm.form.provinceId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "provinceId", $$v)
                  },
                  expression: "form.provinceId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.provinceId !== 0,
                  expression: "form.provinceId !== 0",
                },
              ],
              attrs: {
                label: _vm.$t("settingZones.dialog.city"),
                prop: "cityId",
              },
            },
            [
              _c("BjSelectChinaArea", {
                staticClass: "full-width",
                attrs: {
                  type: "city",
                  all: "",
                  disabled:
                    _vm.form.provinceId === null || _vm.form.provinceId === 0,
                  "parent-code": _vm.form.provinceId,
                },
                on: { change: _vm.changeCity },
                model: {
                  value: _vm.form.cityId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "cityId", $$v)
                  },
                  expression: "form.cityId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.cityId !== 0 || _vm.form.areaId !== 0,
                  expression: "form.cityId !== 0 || form.areaId !== 0",
                },
              ],
              attrs: {
                label: _vm.$t("settingZones.dialog.district"),
                prop: "areaName",
              },
            },
            [
              _c("BjSelectChinaArea", {
                staticClass: "full-width",
                attrs: {
                  type: "area",
                  all: "",
                  disabled: _vm.form.cityId === null || _vm.form.cityId === 0,
                  "parent-code": _vm.form.cityId,
                },
                on: { change: _vm.changeArea },
                model: {
                  value: _vm.form.areaId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "areaId", $$v)
                  },
                  expression: "form.areaId",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingZones.dialog.logistics"),
                prop: "logisticCompanyId",
              },
            },
            [
              _c("BjSelectLogisticCompany", {
                attrs: {
                  value: _vm.form.logisticCompanyId,
                  "default-options": {
                    label: _vm.form.logisticCompanyName,
                    value: _vm.form.logisticCompanyId,
                  },
                },
                on: { change: _vm.onLogistic },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingZones.dialog.business"),
                prop: "logisticBusinessId",
              },
            },
            [
              _c("BjSelectLogisticBusiness", {
                attrs: {
                  value: _vm.form.logisticBusinessId,
                  disabled: !_vm.form.logisticCompanyId,
                  "default-params": _vm.defaultParams,
                  "default-options": {
                    label: _vm.form.logisticBusinessName,
                    value: _vm.form.logisticBusinessId,
                  },
                  placeholder: _vm.form.logisticCompanyId
                    ? _vm.$t("chooseText")
                    : _vm.$t("settingZones.dialog.selectLogisticsValid"),
                },
                on: { change: _vm.onBusiness },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }